<template>
  <div>
    <b-alert show :variant="classType" dismissible @dismissed="closeNotification()">
      <ul v-if="multiMessage">
        <li v-for="item in notification.message" :key="item">{{ item }}</li>
      </ul>
      <span v-else>
        {{ notification.message }}
      </span>
    </b-alert>
  </div>
</template>

<style scoped>
  /* Make the alert visible above a modal */
  .notification-msg {
    z-index: 10000 !important;
  }

  >>> .alert {
    border:4px solid white;
    box-shadow:1px 1px 12px rgba(0,0,0,0.25), 0 0 2px inset black;
  }

  >>> .alert-danger {
    box-shadow:1px 1px 22px black, 0 0 2px inset black;
    font-weight:bold
  }

</style>

<script>
  import { BAlert } from 'bootstrap-vue';
  import * as types from '../store/mutation-types'

  export default {
    data () {
      return {
      }
    },

    computed: {
      classType () {
        if (this.notification.type === 'error') { return 'danger'; }
        return this.notification.type;
      },
      multiMessage () {
        return Array.isArray(this.notification.message)
      }
    },

    methods: {
      // Emit an event that this notification has been closed
      closeNotification () {
        this.$store.commit(types.HIDE_NOTIFICATION, this.notification.index);
      }
    },

    props: {
      notification: {
        required: true,
        type: Object
      }
    },
    components: {
      BAlert
    }
  }
</script>



// WEBPACK FOOTER //
// Notification.vue?0eafb216